"use client";
import { useDevToolsDetection } from "@/lib/hooks/devtools.hooks";
import { useGetApplicationConfigQuery } from "@/lib/redux";
import { useEffect, useMemo, useState } from "react";

const DevToolsWarningOverlay = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#000",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2147483647,
        color: "#fff",
        textAlign: "center",
        padding: "20px",
      }}>
      <p style={{ fontSize: "48px", margin: "0 0 16px" }}>⚠️</p>
      <h2 style={{ fontSize: "22px", fontWeight: 600, margin: "0 0 12px" }}>
        Developer Tools Detected
      </h2>
      <p
        style={{
          fontSize: "16px",
          color: "#ccc",
          margin: 0,
          maxWidth: 400,
          lineHeight: 1.6,
        }}>
        Please close the developer tools to continue using this application.
      </p>
    </div>
  );
};

const DevToolsDetector = ({ children }) => {
  const { data: applicationConfigData } = useGetApplicationConfigQuery();
  const devToolsEnabled = useMemo(
    () => applicationConfigData?.data?.appconfig?.devToolsEnabled,
    [applicationConfigData],
  );

  const showOverlay = useMemo(() => {
    if (typeof window === "undefined") return false; // SSR guard
    if (devToolsEnabled === undefined || devToolsEnabled === null) return false; // Still loading config or not set, allow devtools
    return devToolsEnabled === false; // Show overlay only if explicitly set to false
  }, [devToolsEnabled]);



  const { isOpen, triggerSource } = useDevToolsDetection({
    enabled: showOverlay,
    // flags: { pollingEnabled:true, keyboardEnabled, rightClickEnabled },
    onOpen: () => console.log("⚠️  DevTools OPENED"),
    onClose: () => console.log("✅  DevTools CLOSED"),
    onShortcut: ({ label }) => console.log(`⌨️  Shortcut: ${label}`),
    onRightClick: () => console.log("🖱️  Right-click detected"),
  });

  if (showOverlay && isOpen) {
    return <DevToolsWarningOverlay />;
  }

  return children;
};

export default DevToolsDetector;
